// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Components
import CardInfo from '../CardInfo';
import CardTags from '../cardTags/CardTags';

// Props and Context
const propTypes = {
  cardType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tags: PropTypes.array,
  title: PropTypes.string.isRequired,
  withoutDetails: PropTypes.bool,
};

const defaultProps = {
  subtitle: '',
  tags: [],
  withoutDetails: false,
};

const contextTypes = {
  t: PropTypes.func,
};

function Resource(props) {
  const {
    cardType,
    subtitle,
    tags,
    title,
    withoutDetails,
  } = props;

  return (
    <div className="card__details__wrapper">
      <div>
        <CardInfo title={title} subtitle={subtitle} />
        {!withoutDetails &&
          <div className="card__footer">
            <CardTags tags={tags} />
            <div className="card__actions">
              <span className={`card__type card__type--${cardType}`} />
            </div>
          </div>
        }
      </div>
    </div>
  );
}

Resource.contextTypes = contextTypes;
Resource.propTypes = propTypes;
Resource.defaultProps = defaultProps;

export default withRouter(Resource);



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/cardDetails/Resource.js